import React from 'react';
import { TwButtonType } from '../../../TwButtons/TwButtons';
import Grid from '@mui/material/Grid';
import { TwButton } from '../../../TwButtons/TwButtons';
import AddIcon from '@mui/icons-material/Add';
import { MeasurementSystem } from '../../../../providers/User/User.model';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

interface TwCommodityFooterProps {
  addNewCommodity: () => void;
  totalQty: number;
  totalWeight: number;
  measurementSystem: MeasurementSystem;
}

const TwCommodityFooter = ({ addNewCommodity, totalQty, totalWeight, measurementSystem }: TwCommodityFooterProps): JSX.Element => {
  return (
    <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
      <Grid item xs={5}>
        {/* Add item button */}
        <TwButton
          startIcon={<AddIcon />}
          label="Add item"
          type={TwButtonType.text}
          action={addNewCommodity}
        ></TwButton>
      </Grid>
      <Grid item xs={2} sx={{ textAlign: 'right' }}>
        {/* Total */}
        <Typography
          sx={{
            color: '#6B7280',
            fontWeight: 500,
            m: '0 10px 0 15px',
            fontSize: '14px',
            lineHeight: 1.5,
            alignSelf: 'center'
          }}
        >
          TOTAL
        </Typography>
      </Grid>
      <Grid item xs={2}>
        {/* Qty */}
        <Box display="flex" alignItems="center" height="100%">
          <Typography
            sx={{
              color: '#6B7280',
              fontWeight: 500,
              m: '0 10px 0 15px',
              fontSize: '14px',
              lineHeight: 1.5,
              alignSelf: 'center'
            }}
          >
            Qty:
          </Typography>
          {/* Qty value */}
          <Typography
            component={'label'}
            sx={{
              color: '#6B7280',
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: 1.5,
              alignSelf: 'center',
              m: '0px 0px 0px 30px'
            }}
          >
            {!totalQty ? '' : totalQty}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={2.5}>
        {/* Weight */}
        <Box display="flex" alignItems="center" height="100%">
          <Typography
            sx={{
              color: '#6B7280',
              fontWeight: 500,
              m: '0 10px 0 15px',
              fontSize: '14px',
              lineHeight: 1.5,
              alignSelf: 'center'
            }}
          >
            Weight:
          </Typography>
          {/* Weight value */}
          <Typography
            component={'label'}
            sx={{
              color: '#6B7280',
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: 1.5,
              alignSelf: 'center',
              m: '0px 0px 0px 15px'
            }}
          >
            {!totalWeight ? '' : `${totalWeight} ${measurementSystem === MeasurementSystem.IMPERIAL ? 'lb' : 'kg'}`}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={0.5}>
        {/* Empty */}
      </Grid>
    </Grid>
  );
};

export default TwCommodityFooter;